<template lang="pug">
  div.slits
    figure.slit(v-for="(n, i) in slits",:style="sty(n.pos)")
      //img(:src="'./static/front/' + item.code + '.svg'")
      //div.mm(v-if="i < slits.length - 1",:style="slitm(i)")
      //  span {{ Math.round(n.span) }}cm
      //div.mh(v-if="i === slits.length - 1")
      //  span {{ Math.round(wcmh) }}cm
      div.code {{item.code}}
</template>

<script>
export default {
  name: 'SizeWidth',
  components: {
  },
  data () {
    return {
      wcmw: 0,
      wcmh: 0,
      item: {},
      slits: [],
      set: {}
    };
  },
  props: {
  },
  computed: {
  },
  watch: {
    number () {
      this.update();
    },
    sets () {
      this.update();
    },
    view () {
      this.update();
    }
  },
  methods: {
    sty (num) {
      if (this.sets[this.number] === undefined) return false;
      return {
        height: this.c2p(this.sets[this.number].size[1]) + 'px',
        left: this.c2p(num) + 'px'
      };
    },
    slitm (i) {
      if (this.sets[this.number] === undefined) return false;
      return {
        width: (this.c2p(this.sets[this.number].slits[i].span) - 2) + 'px'
      };
    },
    update () {
      this.set = this.sets[this.number];
      if (this.set === undefined) return false;
      if (this.set.slits[0].slit !== undefined) {
        this.item = this.set.slits[0].slit;
      } else {
        this.updateSlit(this.set);
        this.sets.splice(this.number, 1, this.set);
      }
      this.slits = this.set.slits;
      if (this.slits[(this.slits.length - 1)].slit !== undefined) {
        this.wcmh = this.slits[this.slits.length - 1].slit.pos;
      }
      for (let i = 0; i < this.slits.length - 1; i++) {
        this.slits[i].span = this.slits[i + 1].pos - this.slits[i].pos;
      }
    }
  },
  created () {
    this.update();
  }
};
</script>

<style lang="stylus" scoped>
  .slits
    position absolute
    left 0
    bottom 0
    display flex
    z-index 3
    .slit
      width 10px
      height 233px
      position absolute
      left 0
      bottom 0
      user-select none
      &:first-child
        img
          transform translate(-20%,0)
      &:last-child
        img
          transform translate(-80%,0)
      img
        transform translate(-50%,0)
        position absolute
        left 0
        top 0
        width 100%
        height 100%
        box-shadow 1px 1px 3px #00000033
        .preview &
          box-shadow none
      .code
        /*display block*/
        text-align center
        position absolute
        top 50%
        left -25px
        width 100%
        font-size 14px
        z-index 2
        transform rotate(-90deg)
        text-shadow 1px 1px 1px #ffffff,-1px -1px 1px #ffffff,-1px 1px 1px #ffffff,1px -1px 1px #ffffff,1px 0px 1px #ffffff,-1px 0px 1px #ffffff,0px 1px 1px #ffffff,0 -1px 1px #ffffff
        /*.preview &*/
          /*display block*/
    .mm
      position absolute
      width 100px
      height 10px
      left 1px
      top -25px
      font-size 12px
      border-left 1px solid #000000
      border-right 1px solid #000000
      text-align center
      &:before
        content ""
        display block
        position absolute
        left 0
        top 50%
        width 100%
        height 1px
        background-color #000000
      span
        display block
        margin-top -15px
    .mh
      position absolute
      width 10px
      height 100%
      left 10px
      top 0
      font-size 12px
      border-top 1px solid #000000
      border-bottom 1px solid #000000
      text-align center
      &:before
        content ""
        display block
        position absolute
        left 50%
        top 0
        width 1px
        height 100%
        background-color #000000
      span
        position absolute
        left 5px
        top 50%
        transform rotate(-90deg) translate(50%,0)
        display block
</style>



// WEBPACK FOOTER //
// src/components/front/SlitsPreview.vue